/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BadRequest,
  GetCarColors200ResponseInner,
  InternalServerError,
  ServiceUnavailable,
  Unauthorized,
  UnprocessableEntity,
} from '../models/index';
import {
    BadRequestFromJSON,
    BadRequestToJSON,
    GetCarColors200ResponseInnerFromJSON,
    GetCarColors200ResponseInnerToJSON,
    InternalServerErrorFromJSON,
    InternalServerErrorToJSON,
    ServiceUnavailableFromJSON,
    ServiceUnavailableToJSON,
    UnauthorizedFromJSON,
    UnauthorizedToJSON,
    UnprocessableEntityFromJSON,
    UnprocessableEntityToJSON,
} from '../models/index';

export interface GetCarColorsRequest {
    sort?: GetCarColorsSortEnum;
}

/**
 * 
 */
export class CarColorsApi extends runtime.BaseAPI {

    /**
     * 車色一覧情報取得
     */
    async getCarColorsRaw(requestParameters: GetCarColorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetCarColors200ResponseInner>>> {
        const queryParameters: any = {};

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/car-colors`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCarColors200ResponseInnerFromJSON));
    }

    /**
     * 車色一覧情報取得
     */
    async getCarColors(requestParameters: GetCarColorsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetCarColors200ResponseInner>> {
        const response = await this.getCarColorsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetCarColorsSortEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetCarColorsSortEnum = typeof GetCarColorsSortEnum[keyof typeof GetCarColorsSortEnum];
